/**
 * 다국어(i18n) 설정 — 기본 영문, 한국어 지원
 * - 우선순위: URL 쿼리(?lang=en|ko) → 사용자가 고른 언어(localStorage) → 브라우저 언어 → 영문
 * - 언어 추가 시 locales/에 JSON 추가 후 resources에 등록
 * - ?lang=en 으로 접속하면 즉시 영문으로 전환 + localStorage에 저장(카카오 등 외부 심사용 고정 링크)
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ko from './locales/ko.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
    },
    fallbackLng: 'en',          // 기본 = 영문
    supportedLngs: ['en', 'ko'],
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'freematch-lang',
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
